import React, { useState } from 'react';
import DataVisualizationView from '../../components/common/DataVisualizationView';
import Table from '../../components/common/Table/Table';
import { tables } from '../../constants';
import FilterComponent from '../../components/common/Filter';

/**
 * Usage History Component
 *
 * This component is part of the data visualization stucture and is specifically
 * designed to handle the "Usage History" data. It currently renders a table to
 * display the data but will support graph visualizations in the future.
 *
 * Reponsabilities:
 * - Define how the "Usage History" data is presented.
 * - Render the appropiate components (e.g., Table, Graphs) for this data type.
 *
 * Future enhancements:
 * - Integration of graphs to complement or replace the table for better data insights.
 *
 * @returns {JSX.Element}
 */

const UsageHistory = () => {
  const [filterValues, setFilterValues] = useState({ event_id: '' });

  const handleApplyFilter = (newFilters) => {
    setFilterValues(newFilters);
  };

  const handleClearFilter = () => {
    setFilterValues({ event_id: '' });
  };

  return (
    <DataVisualizationView
      dataType={tables.usage}
      filterComponent={
        <FilterComponent
          onApplyFilter={handleApplyFilter}
          onClearFilter={handleClearFilter}
          initialFilterValues={filterValues}
          isFilterLoading={false}
        />
      }
      filterParams={filterValues}
    >
      {({ currentRecords, columns }) => {
        return <Table columns={columns} data={currentRecords} />;
      }}
    </DataVisualizationView>
  );
};

export default UsageHistory;
